import { BASE_URL } from 'utils/constant';
import { UploadResult, UploadHistoryResponse } from 'pages/points-management/PointsManagementType';
import axiosClient from './axios';

// Mock data for upload history
const mockUploadHistory: UploadHistoryResponse = {
  records: [
    {
      id: 1,
      uploadDate: '2025-01-25T10:30:00',
      fileName: 'sales_data_january.xlsx',
      totalRecords: 1000,
      successCount: 950,
      errorCount: 50,
      fileUrl: 'mock-url-1'
    },
    {
      id: 2,
      uploadDate: '2025-01-24T14:15:00',
      fileName: 'sales_data_december.xlsx',
      totalRecords: 850,
      successCount: 820,
      errorCount: 30,
      fileUrl: 'mock-url-2'
    },
    {
      id: 3,
      uploadDate: '2025-01-23T09:45:00',
      fileName: 'sales_data_november.xlsx',
      totalRecords: 1200,
      successCount: 1150,
      errorCount: 50,
      fileUrl: 'mock-url-3'
    }
  ],
  total: 3
};

export const uploadSalesFile = async (formData: FormData): Promise<UploadResult> => {
  try {
    const response = await axiosClient.post(`/loyalty/import`, formData)

  return response.data
  } catch (error) {
    throw new Error('Failed to upload file');
  }
};

export const getUploadHistory = async (page: number, pageSize: number): Promise<UploadHistoryResponse> => {
  try {
    const response = await axiosClient.get(`/loyalty/sales-upload-history?page=${page}&pageSize=${pageSize}`)
    
    return {
      records: response.data.records,
      total: response.data.total
    };
  } catch (error) {
    throw new Error('Failed to fetch upload history');
  }
};

export const downloadUploadFile = async (fileUrl: string): Promise<void> => {
  try {
    // Mock download - in real implementation, this would trigger file download
    console.log('Downloading file:', fileUrl);
    
    // Simulate download delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    alert('File download started (mock implementation)');
  } catch (error) {
    throw new Error('Failed to download file');
  }
};
